import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import momentPropTypes from 'react-moment-proptypes';
import ProgressButtons from './ProgressButtons';
import HandlerSelectionSidebarContainer
  from '../../target-node-handler-selector/containers/HandlerSelectionSidebarContainer';
import {
  getSelectedHandlers,
  getCheckedHandlers,
  getHandlers,
  getHandlerIsLoading,
} from '../../target-node-handler-selector/redux/selectors/HandlerSelectors';
import SaveHandlerSelectionModal from '../../target-node-handler-selector/components/SaveHandlerSelectionModal';
import { saveUserHandlerSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import HandlerSelector from '../../target-node-handler-selector/components/HandlerSelector';
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from '../../period-selector/redux/selectors/PeriodSelectionSelectors';
import {
  handlerCheckedActionCreator,
  onDeSelectAllHandlers,
  onSelectAllHandlers,
  retrieveOutboundHandlersRequestActionCreator,
} from '../../target-node-handler-selector/redux/actions/HandlerActions';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
/* eslint-disable import/no-cycle */
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import noop from '../../../../core/modules/common/tools/noop';

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundHandlersRequestActionCreator,
  saveUserHandlerSelectionRequestActionCreator,
  handlerCheckedActionCreator,
  onSelectAllHandlers,
  onDeSelectAllHandlers,
}, dispatch);

const mapStateToProps = state => ({
  selectedHandlersNodes: getSelectedHandlers(state),
  handlersNodes: getHandlers(state),
  checkedHandlers: getCheckedHandlers(state),
  handlerIsLoading: getHandlerIsLoading(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
});

// eslint-disable-next-line react/prefer-stateless-function
class TargetNodeHandlerWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstHandler: true,
      selectionTreeLoaded: false,
      showOnlySelectedHandlers: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedHandlers: [],
      saveSelectionSelections: [],
    };
  }

  componentDidMount() {
    // Only fetch if not already loading
    if (!this.props.handlerIsLoading) {
      this.props.retrieveOutboundHandlersRequestActionCreator({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      }, this.props.checkedHandlers);
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedHandlersNodes;
    // eslint-disable-next-line max-len
    if (this.state.firstHandler && this.props.handlersNodes === nextProps.handlersNodes && nextProps.selectedHandlersNodes.length !== 0) {
      this.setState({
        firstHandler: false,
        showOnlySelectedHandlers: true,
      });
    }

    await this.props.handlersNodes;
    this.setState({
      selectionTreeLoaded: this.props.handlersNodes.length > 0,
    });
  }

  componentDidUpdate(prevProps) {
    // Refetch when dates change
    const datesChanged = (
      !this.props.startDate.isSame(prevProps.startDate, 'day') ||
      !this.props.endDate.isSame(prevProps.endDate, 'day')
    );

    if (datesChanged) {
      this.props.retrieveOutboundHandlersRequestActionCreator({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      }, this.props.checkedHandlers);
    }
  }

  onSelectAllHandlers = () => {
    this.props.onSelectAllHandlers(this.props.handlersNodes);
  };

  onDeSelectAllHandlers = () => {
    this.setState({
      showOnlySelectedHandlers: false,
    });
    this.props.onDeSelectAllHandlers();
  };

  onSelectHandler = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedHandlers: false,
      });
    } else {
      this.setState({
        firstHandler: false,
      });
    }
    this.props.handlerCheckedActionCreator(selected);
  };

  onToggleShowOnlySelectedHandlers = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedHandlers: !this.state.showOnlySelectedHandlers,
    });
  };

  openSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedHandlers: this.props.checkedHandlers,
      saveSelectionSelections: this.props.selections,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedHandlers }) => {
    this.props.saveUserHandlerSelectionRequestActionCreator(
      name,
      checkedHandlers,
    );
    this.closeSaveSelectionModal();
  };

  render() {
    const tempNodes = [
      {
        value: 'DUMMY',
        label: 'LOADING...',
        expandDisabled: true,
        children: this.props.checkedHandlers && this.props.checkedHandlers.length > 0 ? this.props.checkedHandlers.map(initialItem => ({ value: initialItem, label: '' })) : [],
      }];
    const handlerSelectorProps = {
      selected: this.props.checkedHandlers,
      // eslint-disable-next-line max-len
      isShowOnlySelected: !this.state.selectionTreeLoaded ? true : this.state.showOnlySelectedHandlers,
      // eslint-disable-next-line max-len,no-nested-ternary
      handlerNodes: !this.state.selectionTreeLoaded ? tempNodes : this.state.showOnlySelectedHandlers ?
        this.props.selectedHandlersNodes : this.props.handlersNodes,
      onSelect: !this.state.selectionTreeLoaded ? noop : this.onSelectHandler,
      onSelectAll: !this.state.selectionTreeLoaded ? noop : this.onSelectAllHandlers,
      onDeSelectAll: !this.state.selectionTreeLoaded ? noop : this.onDeSelectAllHandlers,
      // eslint-disable-next-line max-len
      onShowOnlySelected: !this.state.selectionTreeLoaded ? noop : this.onToggleShowOnlySelectedHandlers,
      openSaveSelectionModal: !this.state.selectionTreeLoaded ? noop : this.openSaveSelectionModal,
    };

    const selectionCriteria = this.props.children.report.selectionCriteria.items;
    const SC_CODE = sc.SC091;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;
    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        {this.state.showSaveSelectionModal &&
        <SaveHandlerSelectionModal
          saveSelection={this.saveSelection}
          closeModal={this.closeSaveSelectionModal}
          checkedHandlers={this.state.saveSelectionCheckedHandlers}
          selections={this.state.saveSelectionSelections}
        />
        }
        <div className="operator-sidebar">
          <HandlerSelectionSidebarContainer
            report={this.props.children.report}
          />
        </div>

        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <HandlerSelector
                title="HANDLER"
                {...handlerSelectorProps}
              />
            </div>
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>
      </div>);
  }
}

TargetNodeHandlerWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  retrieveOutboundHandlersRequestActionCreator: PropTypes.func,
  selectedHandlersNodes: PropTypes.arrayOf(PropTypes.object),
  handlersNodes: PropTypes.arrayOf(PropTypes.object),
  checkedHandlers: PropTypes.arrayOf(PropTypes.string),
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    handlers: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  saveUserHandlerSelectionRequestActionCreator: PropTypes.func,
  handlerCheckedActionCreator: PropTypes.func,
  onSelectAllHandlers: PropTypes.func,
  onDeSelectAllHandlers: PropTypes.func,
  setDirections: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
};

/* Needed for prop-types with cloneElement */
export const ConnectedTargetNodeHandlerWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetNodeHandlerWizardContainer);

export default (ConnectedTargetNodeHandlerWizardContainer);
